export const apiUrl = "https://teste.centrointegrar.com.br/cms";
// export const apiUrl = "http://teste.centrointegrar.com.br/cms";
// export const apiUrl = "http://localhost:8080/cms";
export const authorizationBasicToken = "Basic aabcc3e849d019ddd567f420afd121775ffe4f6f56c15a5d6eaa1e681d3c";
